import React from "react";
import "./BuildingConstruction.css";

const BuildingConstruction = () => {
  return (
    <div>
      <h1>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugit, ex?
      </h1>
    </div>
  );
};

export default BuildingConstruction;
